import ComponentManager from '@/Management/ComponentManager';
import MultiSelectDropDownListFactory from '@/Factories/ControlFactories/MultiSelectDropDownListFactory';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import CustomMultiDropDownViewModel from '@/Components/CustomDropDown/CustomMultiDropDown/CustomMultiDropDownViewModel';

export default class CustomMultiDropDownFactory extends MultiSelectDropDownListFactory {

    /**
     * @override 
     */
    public context: DetailViewContext;

    public constructor(params) {
        super(params);
    }
    
    /**
     * @override 
     */
    protected createViewModel(params: object): CustomMultiDropDownViewModel {
        return new CustomMultiDropDownViewModel(params);
    }

    /**
     * @override 
     */
    protected createViewModelParameter(): any {
        const params = super.createViewModelParameter();
        params.dto = this.context.genericObject.getObservable<string>(this.detailViewItem.name);

        return params;
    }
    
    /**
     * Must be overwritten, parent class creates fake-property in generic object
     * Data is created in CustomSingleDropDownViewModel
     */
    protected getData(): KnockoutObservable<any> {
        return null;
    }
}

ComponentManager.setFactory('CustomMultiDropDown', CustomMultiDropDownFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');